import { Button } from 'antd';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { tabs } from './config';
import Widget from '../../widget';
import Incidents from './incidents';
import { widgetTypes } from '../../config';
import CorrectiveActions from './corrective-actions';
import { PopoverContent } from '../../../../../screens/Modules/pme/screens/dashboard/style';

const RecentEvents = ({ selectedProject }) => {
  const { t } = useTranslation();
  const [showIncidents, setShowIncidents] = useState(false);
  const [activeKey, setActiveKey] = useState(tabs[0].key);

  return (
    <Widget
      title={t('Supply Chain Monitoring')}
      tooltip={(
        <PopoverContent >
          <h2>
            {t('Supply Chain Monitoring')}
          </h2>
          <p>
            {t('Incidents and corrective actions reported by your information sources in connection with the selected supply chain.')}
          </p>
        </PopoverContent>
      )}
      type={widgetTypes.NO_MIN_WIDTH}
      header={(
        <div className="flex-row flex-1 end">
          {tabs.map((_t, i) => (
            <Button
              type={activeKey === _t.key ? 'primary' : 'default'}
              onClick={() => {
                if (_t.key === 'correctiveActions' && !showIncidents) {
                  setShowIncidents(true);
                }
                setActiveKey(_t.key)
              }}
              key={`${_t.key}-tabs`}
              className={`${i === tabs.length - 1 ? '' : 'w-mr'} ${activeKey !== _t.key ? 'gray-btn' : ''}`}
            >
              {t(_t.label)}
            </Button>
          ))}
        </div>
      )}
    >
      <section style={{ minHeight: 482 }}>
        <div style={{ display: activeKey === 'localisedIncidents' ? 'block' : 'none' }}>
          <Incidents selectedProject={selectedProject} />
        </div>
        {showIncidents && (
          <div style={{ display: activeKey === 'correctiveActions' ? 'block' : 'none' }}>
            <CorrectiveActions selectedProject={selectedProject} />
          </div>
        )}
      </section>
    </Widget>
  );
};

export default RecentEvents;
